<dx-data-grid height="600"
    #dataGrid
    id="dataGrid"
    [dataSource]="dataStore"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [remoteOperations]="{ paging: true}"
    [editing]="{ allowUpdating: false, allowAdding: false, allowDeleting: false }"
>
    <dxi-column caption="Zeitstempel" dataField="timestamp" dataType="datetime" alignment="left" cellTemplate="utcDateTemplate"></dxi-column>
    <div *dxTemplate="let data of 'utcDateTemplate'">
    {{ data.value | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}
</div>
    <dxi-column caption="Dauer (Min.)" dataField="duration_value" dataType="number" alignment="right" cellTemplate="durationTemplate">
        <div *dxTemplate="let data of 'durationTemplate'">
            <span *ngIf="data.value !== null && data.value !== undefined; else noDuration">
        {{ (data.value / 60) | number:'1.2-2' }} min
    </span>
    <ng-template #noDuration>-</ng-template>
        </div>
    </dxi-column>
    <dxi-column caption="Meldung" dataField="text_value" dataType="string" alignment="left"></dxi-column>

    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxo-pager
        [showPageSizeSelector]="false"
        [allowedPageSizes]="[10]"
        [showNavigationButtons]="true"
        [showInfo]="true"
        [visible]="true"
    ></dxo-pager>
</dx-data-grid>

